module.exports = __webpack_public_path__ + "img/img1.2874adf1.png";